import React from 'react';
import { MinusIcon, PlusIcon } from '@heroicons/react/solid';
import { ReserveFormAdminReservation } from '@/components/reserve/Reserve/views/ReserveFormAdminReservation';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export const ReserveFormOtherUserReservation: React.FC = () => {
  const { allowOthers, setEnableAdminReservation, enableAdminReservation } =
    useReserveForm();
  if (!allowOthers) return null;

  return (
    <div className="text-left">
      <div>
        <button
          onClick={(ev) => {
            ev.preventDefault();
            setEnableAdminReservation((x) => !x);
          }}
          className="flex items-center pb-2 text-secondary [.tactic-v2_&]:text-secondary-foreground"
        >
          {!enableAdminReservation ? (
            <PlusIcon className="mr-1.5 h-6 w-4" />
          ) : (
            <MinusIcon className="mr-1.5 h-6 w-4" />
          )}
          Create Reservation for Another User
        </button>
        <ReserveFormAdminReservation />
      </div>
    </div>
  );
};
